<div class="h-full w-full">
    <div class="h-5/6">
        <div class="border-2 border-black w-full h-full" [id]="mapId"></div>
    </div>

    <div class="h-1/6 mt-2 overflow-y-auto">
        <div class="flex flex-wrap gap-12 items-center h-full">
            @for (geopositionSummary of geopositionSummaryList; track $index; let i = $index) {
                <div class="flex items-center">
                    <mat-icon [svgIcon]="getMarkerIcon(i)" class="icon-size-10"></mat-icon>
                    <div class="flex flex-col font-bold text-md text-primary-500" >
                        <span class="ml-2 mt-1 cursor-pointer" (click)="goToMarker(i * 2)">
                            {{$safeNavigationMigration(geopositionSummaryList[i]?.event) | transloco}}
                        </span>
                        <span class="ml-2 mt-1">
                            {{$safeNavigationMigration(geopositionSummaryList[i]?.geopositionTimestamp) | date: 'HH:mm'}}
                        </span>
                        @if (markerList[i * 2 + 1] != null) {
                            <span (click)="goToMarker(i * 2 + 1)" class="ml-2 mt-1 cursor-pointer text-red-500">
                                {{referenceGeopositionSummaryList[i]?.name ?? getLatLngDisplay(referenceGeopositionSummaryList[i])}}
                            </span>
                        }
                    </div>
                </div>
            }
        </div>
    </div>
</div>